import { useContext, useMemo } from 'react'
import { mealHistory } from './history'
import { MealLogContext } from './MealLogContext'
import type { MealHistory } from './types'

export interface UseMealLogResult extends MealHistory {
  loading: boolean
}

// One meal's cook log: its entries newest first, times cooked and last-cooked date.
export function useMealLog(mealId: string | null): UseMealLogResult {
  const state = useContext(MealLogContext)
  if (!state) throw new Error('useMealLog must be used within MealLogProvider')
  const history = useMemo(() => mealHistory(state.entries, mealId), [state.entries, mealId])
  return { ...history, loading: state.loading }
}
